<template>
    <div class="popup" v-show="show">
        <transition name="fade">
            <div class="mask" :style="`background-color: ${bgColor};opacity:${opacity}`" v-show="show"></div>
        </transition>
        <div class="popup-content">
           <slot/>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        show: Boolean,
        bgColor: {
            type: String,
            default: ''
        },
        opacity: {
            type: String,
            default: ''
        },
    }
}
</script>
<style lang="less">
@import 'popup.less';
</style>
